module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Arrow-from-bottom-0ff9336863bcb520c030dc12d6189fa9.svg";